import { Button, Grid2, Typography } from '@mui/material';
import { FolderOutlined, RequestQuote } from '@mui/icons-material';
import { Chip } from '@utriper/core-ui';
import { PriceStatus } from '@utriper/core';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { usePriceGroupTab } from 'core/contexts/priceGroupTab';

const PriceGroupTabCard = ({ id, name, priceGroupCount, status }) => {
    const { t: translate, i18n } = useTranslation();
    const history = useHistory();
    const { getStatusColor } = usePriceGroupTab();
    const countLabel = translate('price_group_tab.card.count');
    const countsLabel = translate('price_group_tab.card.counts');
    const priceGroupCountLabel = `${priceGroupCount} ${priceGroupCount === 1 ? countLabel : countsLabel}`;

    const statusColor = getStatusColor(status);
    const statusLabel = PriceStatus.getTranslatedName(PriceStatus.status, status, i18n.language);

    const handleClick = () => {
        history.push(`/price-list/${id}`);
    };

    return (
        <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
            <Button sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', gap: '16px', p: '16px', backgroundColor: 'white', border: 'solid 1px #13131340', borderRadius: '8px', boxShadow: 'var(--shadow-card)', boxSizing: 'border-box', width: '100%', textTransform: 'none', overflow: 'hidden' }} onClick={handleClick}>
                <Grid2 container width="100%" justifyContent="space-between" alignItems="flex-start">
                    <FolderOutlined sx={{ fontSize: '32px', color: 'var(--color-utriper-blue)' }} />
                    <Chip label={statusLabel} sx={{ background: `${statusColor}40`, color: `${statusColor}`, padding: '8px 4px', borderRadius: '4px' }} />
                </Grid2>
                <Typography fontSize={20} fontWeight={700} sx={{ color: '#131313', maxWidth: '100%' }} noWrap>
                    {name}
                </Typography>
                <Grid2 container alignItems="center" gap="8px" sx={{ color: '#131313bf' }}>
                    <RequestQuote />
                    <Typography fontSize={16} fontWeight={500} sx={{ maxWidth: '100%' }} noWrap>
                        {priceGroupCountLabel}
                    </Typography>
                </Grid2>
            </Button>
        </Grid2>
    );
};

export default PriceGroupTabCard;
